module.exports = __webpack_public_path__ + "static/img/product04.429afe7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/product04.png
// module id = POtC
// module chunks = 1